// extracted by mini-css-extract-plugin
export var internalNoteEditor = "_h1-1";
export var quotedThread = "_h1-0";